import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import SuperAdminSidebar from '../components/SuperAdminSidebar';
import AdminTopBar from '../components/AdminTopBar';
import { API_ENDPOINTS } from '../config/api';
import EvaluationResponseView from '../EvaluationResponseView';

const InstitutionalEvaluationResponsePage = () => {
  const { responseId } = useParams();

  const breadcrumbItems = [
    { href: '/institutional-admin/dashboard', label: 'Dashboard' },
    { href: '/institutional-admin/evaluations', label: 'Evaluations' },
    { label: 'Individual Result' },
  ];

  return (
    <div className="d-flex vh-100 overflow-hidden">
      <SuperAdminSidebar variant="institutional" />
      <div className="d-flex flex-column flex-grow-1 min-w-0">
        <AdminTopBar variant="institutional" breadcrumbItems={breadcrumbItems} />
        <Container fluid className="bg-inverse-light p-0 overflow-hidden">
          <EvaluationResponseView
            responseId={responseId}
            apiBase={API_ENDPOINTS.INSTITUTIONAL_ADMIN}
            responseEndpoint="evaluation-responses"
            embedded
            hidePageChrome
            backPath="/institutional-admin/evaluations"
          />
        </Container>
      </div>
    </div>
  );
};

export default InstitutionalEvaluationResponsePage;
